// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ZZlZ","footer":"ModalUpdate_footer__1ZmB7"};